// packages/ui/src/error-reporter.ts
// Единый клиентский репортёр ошибок для B2B, ЛК и Admin
// Автоматически вызывается из withToken/fetchWithToken при network/API ошибках
// + извлекает file/line из stack trace

const BUFFER: Array<{ url: string; ts: number }> = [];
const MAX_PER_MIN = 10;

/** Отправляет ошибку в систему трекинга (error_logs → админка) */
export async function reportClientError(opts: {
  service?: 'b2b' | 'lk' | 'admin';
  severity?: 'error' | 'warning' | 'fatal';
  name: string;
  message: string;
  stack?: string;
  context?: Record<string, unknown>;
}): Promise<void> {
  if (typeof window === 'undefined') return; // SSR — пропускаем

  // Rate limit: не более 10 ошибок в минуту с одного клиента
  const now = Date.now();
  const recent = BUFFER.filter((e) => now - e.ts < 60_000);
  if (recent.length >= MAX_PER_MIN) return;
  BUFFER.push({ url: window.location.href, ts: now });

  try {
    const stack = opts.stack ?? '';
    // Парсим стек для извлечения файла и строки
    const match = stack.match(/\(?(https?:\/\/[^)\s]+\/([^?)\s]+\.tsx?)):(\d+):(\d+)\)?/);
    const file = match?.[2] ?? null;
    const line = match?.[3] ? Number(match[3]) : null;

    const API_BASE = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:4000';
    const service = opts.service ?? (process.env.NEXT_PUBLIC_APP_NAME as 'b2b' | 'lk' | 'admin') ?? 'b2b';
    await fetch(`${API_BASE}/api/internal/errors`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        service,
        severity: opts.severity ?? 'error',
        name: opts.name,
        message: opts.message,
        stack: stack || undefined,
        context: {
          ...opts.context,
          file,
          line,
          url: window.location.href,
          userAgent: navigator.userAgent,
          timestamp: new Date().toISOString(),
        },
      }),
      // Не блокируем страницу
      keepalive: true,
    });
  } catch {
    // Тихо — репортёр не должен сам падать
  }
}
